interface PageHeaderProps {
  title: string;
  subtitle: string;
}

const PageHeader = ({ title, subtitle }: PageHeaderProps) => (
  <div className="bg-gradient-to-br from-primary-blue to-secondary-blue py-20 pb-[60px] text-center text-white max-[768px]:py-[60px] max-[768px]:pb-10">
    <div className="container">
      <h1 className="mb-4 text-[3.5rem] font-bold [text-shadow:2px_2px_4px_rgba(0,0,0,0.3)] max-[968px]:text-4xl max-[768px]:text-3xl">
        {title}
      </h1>
      <p className="mx-auto max-w-[600px] text-xl leading-relaxed opacity-90 max-[768px]:text-base">
        {subtitle}
      </p>
    </div>
  </div>
);

export default PageHeader;
